import React, { Component } from "react";
import { Row, Col, Button, Modal, Typography, Form, Statistic, Tag, Spin, Divider } from 'antd';
//componentes
import { PaperClipOutlined } from "@ant-design/icons"
import CustomAvatar from "../../../Widgets/Avatar/Avatar";
import { cargaLogoUrl } from "../../../Helpers/CargarLogos";

const { Text } = Typography;
const axios = require('axios').default;
const moment = require('moment');


/**
 *
 *
 * @class ModalTransaccionesDetalle
 * @extends {Component}
 */
class ModalTransaccionesDetalle extends Component {


    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            transaccion: {
                _id: 0,
                concepto: '',
                proyecto_id: {
                    nombre: ''
                },
                cuenta_id: {
                    nombre: ''
                },
                cuenta_destino_id: {
                    nombre: ''
                },
                monto: 0,
                fecha: new Date(),

                tipo: 0,

                usuario_id: {
                    nombre: ''
                },
                area_id: {
                    nombre: ''
                },
                rubro_id: {
                    nombre: ''
                },
                descripcion: '',
                comprobantes: [],
                actualiza_saldo: false,
                descripcion: '',

                facturas: [{
                    factura_id: {

                    },
                    monto_abonado: 0
                }],

                conceptos: []
            },
        }

    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        this.getTransaccion()
    }


    /**
    * @memberof ModalTran
    * @method getTransaccion
    * @description Obtiene la informacion de la transacciones para el modal de detalle. Actualiza el state
    * con informacion obtenida.
    */
    getTransaccion = () => {
        this.setState({ loading: true })
        axios.get(`/transacciones/${this.props.transaccion_id}`, {
            params: {
                id: this.props.id
            }
        }).then(({ data }) => {
            console.log("{data}", data);

            this.setState({ transaccion: data });
        })
            .catch(error => {
                console.log('error', error)
            })
            .finally(() => {
                this.setState({ loading: false })
            })

    }

    render() {
        const { transaccion } = this.state;
        return (
            <Spin spinning={false}>
                <Form layout="vertical"   >
                    <Divider orientation="left">Información General</Divider>
                    <Row justify="center">

                        <Col span={8}>
                            <Form.Item label="Concepto">
                                <Text type="secondary">
                                {transaccion.concepto || 'Sin concepto asignado'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Folio">
                                <Text type="secondary">
                                {transaccion.folio || 'Sin folio asignado'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Fecha">
                                <Text type="secondary">
                                {transaccion.fecha
                                    ? moment(transaccion.fecha).format('YYYY-MM-DD')
                                    : 'Sin fecha registrada'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Autor" name="usuario_id">
                                <div>
                                    {transaccion.usuario_id?.nombre || transaccion.usuario_id?.apellidos ? 
                                    (
                                        <>
                                            <CustomAvatar
                                                name={`${transaccion.usuario_id?.nombre} ${transaccion.usuario_id?.apellidos}`}
                                                size="small"
                                                style={{ marginRight: '5px' }}
                                            />
                                            {`${transaccion.usuario_id?.nombre} ${transaccion.usuario_id?.apellidos}`}
                                        </>
                                    ) : (
                                        <Text type="secondary">Sin autor asignado</Text>
                                    )}
                                </div>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Editores" name="editado_por">
                                {Array.isArray(transaccion.editado_por) && transaccion.editado_por.length > 0 ? (
                                    [...new Map(
                                        transaccion.editado_por
                                            .filter(e => e?.usuario_id?._id)
                                            .map(e => [e.usuario_id._id, e]) 
                                    ).values()].map((it, index) => {
                                        const user = it.usuario_id
                                        const usuario = [user.nombre, user.apellidos].filter(Boolean).join(' ')
                                        return (
                                            <div key={user._id || index} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                <CustomAvatar
                                                    name={usuario || 'Usuario desconocido'}
                                                    size="small"
                                                    style={{ marginRight: 5 }}
                                                />
                                                {usuario || <Text type="secondary">Usuario desconocido</Text>}
                                            </div>
                                        )
                                    })
                                ) : (
                                    <Text type="secondary">Sin editores asignados</Text>
                                )}
                            </Form.Item>


                        </Col>

                        <Col span={8}>
                            <Form.Item label="Descripción">
                                <Text type="secondary">
                                    {transaccion.descripcion || 'Sin descripción'}
                                </Text>
                            </Form.Item>
                        </Col>

                        
                        {/*<Col span={24} >
                            <Form.Item label="Descripción" >
                                <Text type="secondary" >{transaccion.descripcion}</Text>
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item label="Area" >
                                <Text type="secondary" >{transaccion.area_id?.nombre}</Text>
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item label="Rubro" >
                                <Text type="secondary" >{transaccion.rubro_id?.nombre}</Text>
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item label="Empresa" >
                                <Text type="secondary" >{transaccion.empresa_id?.alias}</Text>
                            </Form.Item>
                        </Col> */}


                    </Row>
                    <Divider orientation="left">Información Financiera</Divider>

                    <Row>
                        <Col span={8}>
                            <Form.Item label="Área">
                                <Text type="secondary">
                                    {transaccion.area_id?.nombre || 'Sin área asignada'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Rubro">
                                <Text type="secondary">
                                    {transaccion.rubro_id?.nombre || 'Sin rubro asignado'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Cliente">
                                <Text type="secondary">
                                    {transaccion.cliente_id?.nombre || 'Sin cliente asignado'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Inversión">
                                <Text type="secondary">
                                    {transaccion.inversion_id?.nombre || 'Sin inversión asignada'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Acreedor">
                                <Text type="secondary">
                                    {transaccion.acreedor_id?.acreedor || 'Sin acreedor asignado'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Proveedor">
                                <Text type="secondary">
                                    {transaccion.proveedor_id?.alias || 'Sin proveedor asignado'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Tipo de Pago">
                                <Text type="secondary">
                                    {transaccion.tipo_pago
                                        ? transaccion.tipo_pago !== 2
                                        ? 'Transacción Programada'
                                        : 'Pago en Especie'
                                        : 'Sin tipo de pago asignado'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Facturas (UUID)">
                                <Text type="secondary">
                                    {transaccion.uuid || 'Sin factura asignada'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Cuenta">
                                {transaccion.actualiza_saldo === true ? 
                                (
                                    <Tag color="#87d068" className="tag-actualiza-saldo">Actualiza Saldo</Tag>
                                ) : null}

                                {transaccion.cuenta_id?.nombre ? 
                                (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                        <CustomAvatar
                                            name={transaccion.cuenta_id?.nombre}
                                            src={
                                                transaccion.cuenta_id?.logo?.file
                                                ? cargaLogoUrl('cuentas', transaccion.cuenta_id._id)
                                                : undefined
                                            }
                                            size="small"
                                            color={transaccion.cuenta_id?.color}
                                        />
                                        <Text type="secondary">{transaccion.cuenta_id?.nombre}</Text>
                                    </div>
                                ) : (
                                    <Text type="secondary">Sin cuenta asignada</Text>
                                )}
                            </Form.Item>
                        </Col>


                        <Col span={8}>
                            <Form.Item label="Tipo">
                                <Text type="secondary">
                                    {transaccion.tipo
                                        ? transaccion.tipo === 1
                                        ? 'Ingreso'
                                        : transaccion.tipo === 2
                                        ? 'Egreso'
                                        : 'Traspaso'
                                        : 'Sin tipo asignado'}
                                </Text>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Monto">
                                {transaccion.monto != null ? (
                                    transaccion.tipo == 2 ? (
                                        <Statistic
                                            value={transaccion.monto}
                                            valueStyle={{ fontSize: '16px', fontWeight: 'bold', color: '#FF0000' }}
                                            prefix={'$'}
                                            suffix={'MXN'}
                                        />
                                    ) : (
                                        <Statistic
                                            value={transaccion.monto}
                                            valueStyle={{ fontSize: '16px', fontWeight: 'bold', color: '#00FF19' }}
                                            prefix={'$'}
                                            suffix={'MXN'}
                                        />
                                    )
                                ) : (
                                    <Text type="secondary">Sin monto asignado</Text>
                                )}
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Empresa">
                                {transaccion.empresa_id?.alias ? 
                                (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                        <CustomAvatar
                                            name={transaccion.empresa_id?.alias}
                                            src={
                                                transaccion.empresa_id?.logo?.file
                                                ? cargaLogoUrl('empresas', transaccion.empresa_id._id)
                                                : undefined
                                            }
                                            size="small"
                                            color={transaccion.empresa_id?.color}
                                        />
                                        <Text type="secondary">{transaccion.empresa_id?.alias}</Text>
                                    </div>
                                ) : (
                                    <Text type="secondary">Sin empresa asignada</Text>
                                )}
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Proyectos">
                                {transaccion.proyecto_id?.nombre ? 
                                (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                        <CustomAvatar
                                            name={transaccion.proyecto_id?.nombre}
                                            src={
                                                transaccion.proyecto_id?.logo?.file
                                                ? cargaLogoUrl('proyectos', transaccion.proyecto_id._id)
                                                : undefined
                                            }
                                            size="small"
                                            color={transaccion.proyecto_id?.color}
                                        />
                                        <Text type="secondary">{transaccion.proyecto_id?.nombre}</Text>
                                    </div>
                                ) : (
                                    <Text type="secondary">Sin proyecto asignado</Text>
                                )}
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Subproyectos">
                                {transaccion.subproyecto_id?.nombre ? 
                                (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                        <CustomAvatar
                                            name={transaccion.subproyecto_id?.nombre}
                                            src={
                                                transaccion.subproyecto_id?.logo?.file
                                                ? cargaLogoUrl('subproyectos', transaccion.subproyecto_id._id)
                                                : undefined
                                            }
                                            size="small"
                                            style={{ backgroundColor: transaccion.subproyecto_id?.color }}
                                        />
                                        <Text type="secondary">{transaccion.subproyecto_id?.nombre}</Text>
                                    </div>
                                ) : (
                                    <Text type="secondary">Sin subproyecto asignado</Text>
                                )}
                            </Form.Item>
                        </Col>

                    </Row>

                    {transaccion.conceptos.length > 0 ? <>
                        <Divider orientation="left"> Budgeting </Divider>
                        <Row>
                            {transaccion.conceptos.map(e=> <>
                                <Col span={6}>
                                    <Text ellipsis>
                                        {e.proyecto_id?.nombre || 'Sin proyecto asignado'}
                                    </Text>
                                </Col>

                                <Col span={6}>
                                    <Text ellipsis>
                                        {e.concepto_id?.nombre || 'Sin concepto asignado'}
                                    </Text>
                                </Col>

                                <Col span={6}>
                                    <Text ellipsis>
                                        {e.subconcepto_id?.nombre || 'Sin subconcepto asignado'}
                                    </Text>
                                </Col>

                                <Col span={6}>
                                    <Text ellipsis>
                                        {e.monto != null ? `$ ${e.monto.toMoney(true)} MXN` : 'Sin monto asignado'}
                                    </Text>
                                </Col>

                            </>)}
                        </Row> 
                    </> : null }
                    <Divider orientation="left"> Comprobantes </Divider>
                    <Row>
                        <Col span={24}>
                            <Form.Item>
                                {transaccion.comprobantes && transaccion.comprobantes.length > 0 ? (
                                    transaccion.comprobantes.map((comprobante, index) => (
                                        <>
                                            <a
                                                key={index}
                                                target="_blank"
                                                icon={<PaperClipOutlined />}
                                                href={
                                                    axios.defaults.baseURL +
                                                    "/transacciones/" +
                                                    this.props.transaccion_id +
                                                    "?comprobante=" +
                                                    comprobante.file +
                                                    "&Authorization=" +
                                                    sessionStorage.getItem("token")
                                                }
                                            >
                                                {comprobante.name}
                                            </a>
                                            <br />
                                        </>
                                    ))
                                ) : (
                                    <Text type="secondary">Sin comprobantes adjuntos</Text>
                                )}
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </Spin >

        )
    }
}



export default function (props) {
    const { visible = false, onClose = () => { } } = props
    return <Modal
        visible={visible}
        onCancel={onClose}
        title="Detalle Transacción"
        closable={true}
        destroyOnClose={true}
        footer={<Button 
            onClick={onClose}
            type="primary"
        >
            Cerrar
        </Button>}
    >
        <ModalTransaccionesDetalle {...props} />
    </Modal>

}